import React from 'react';
import { motion } from 'framer-motion';
// import ReactTooltip from 'react-tooltip';

import { AppWrap,MotionWrap } from '../../wrapper';
import {images} from '../../constant'
import './Skills.scss';

let skills=[
  {
    name:'React JS',
    bgColor:'',
    icon:images.react
  },
  {
    name:'Javascript',
    bgColor:'',
    icon:images.javascript
  },
  {
    name:'Node JS',
    bgColor:'',
    icon:images.node
  },
  {
    name:'Git',
    bgColor:'',
    icon:images.git
  },
  {
    name:'HTML5',
    bgColor:'',
    icon:images.html
  },
  {
    name:'CSS-3',
    bgColor:'',
    icon:images.css
  },
  {
    name:'Bootstrap-4.5',
    bgColor:'',
    icon:images.bootstrap
  },
  {
    name:'Express JS',
    bgColor:'',
    icon:images.express
  },
  {
    name:'Mongo DB',
    bgColor:'',
    icon:images.mongoDB
  },

]

//Experiance:
let education=[
  {
   branch:'(B.E)-Shivani Engineering College',
    dep:'Mechanical Engineering',
    duration:'2017 to 2021',
    place:'Thiruchirappalli',
  },
  {
    branch:'(12th)-Vetri Vinayaga Hr.Sec School',
     dep:'Computer Science Group',
     duration:'2016 to 2017',
     place:"Samathuvapuram"
   },
   {
    branch:'(10th)-St.Therasa Metric Hr.Sec School',
     duration:'2015 to 2016',
     place:'Sendurai'
   }
 

]
const Skills = () => {
  return (
    <div>
      <h2 className="head-text skill-head">Skills & Education</h2>

      <div className="app__skills-container">
        <motion.div className="app__skills-list">
          {skills.map((skill) => (
            <motion.div
              whileInView={{ opacity: [0, 1] }}
              transition={{ duration: 0.5 }}
              className="app__skills-item app__flex"
              key={skill.name}
            >
              <div
                className="app__flex"
                style={{ backgroundColor: skill.bgColor }}
              >
                <img src={skill.icon} alt={skill.name} />
              </div>
              <p className="p-text">{skill.name}</p>
            </motion.div>
          ))}
        </motion.div>
        <div className="app__skills-edu">
          {education.map((work) => (
            <motion.div
              className="app__skills-edu-item"
              key={work.duration}
            >
              <div className="app__skills-edu-year">
                <p className="bold-text">{work.duration}</p>
              </div>
          
              <motion.div className="app__skills-edu-works">
                    <motion.div
                      whileInView={{ opacity: [0, 1] }}
                      transition={{ duration: 0.5 }}
                      className="app__skills-edu-dep"
                      data-tip
                      data-for={work.name}
                      key={work.name}
                    >
                      <h4 className="bold-text">{work.branch}</h4>
                      <p className="p-text">{work.dep}</p>
                      <p className='p-text'>{work.place}</p>
                    </motion.div>
                
               
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AppWrap(MotionWrap(Skills, "app__skills"),'skills','app__whitebg');